
import React, { useEffect, useState } from "react";
import ShowcaseOptions from "./ShowcaseOptions";
import { getModels } from "../../services/apiService";
import "./Showcase.css";
import ShowcaseModels from "./ShowcaseModels";
import { useNavigate } from "react-router-dom";

interface Model {
  _id: string;
  name: string;
  type: string;
  description: string;
}

function Showcase() {
  const [models, setModels] = useState<Model[]>([]);
  const userId = localStorage.getItem("userId");
  const [render, setRender] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Testing...")
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/login")
    }
    async function fetchModels() {
      try {
        if (userId) {
          console.log(userId);
          const data = await getModels(userId, false); // Replace with your userId logic
          setModels(data);
          setRender(true);
        }
      } catch (error) {
        console.error("Error fetching models", error);
      }
    }
    fetchModels();
  }, [userId, navigate]);
  return (
    <>
      {render ? (
        models.length > 0 ? <ShowcaseModels models={models} /> : <ShowcaseOptions />
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
}

export default Showcase;
